module.exports = __webpack_public_path__ + "img/moustiquaire a déplacement latéral.00154d51.jpg";